import React from 'react'
import { Link } from 'gatsby'

import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax
} from 'styles/media-queries'

export const Container = styled.div`
  display: flex;
  position: relative;

  ${mediaMax('mobile')} {
    flex-wrap: wrap;
  }
`
export const Wrap = styled.section`
  &.no-footer-nav {
    display: none;
  }
`

export const Content = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  a {
    position: absolute;
    bottom: ${calculateResponsiveSize(30)};
    transform: translateY(${calculateResponsiveSize(55)});
    transition: 0.5s;
  }
  ${mediaMax('mobile')} {
    a {
      bottom: ${calculateMobileResponsiveSize(30)};
      transform: translateY(0);
    }
  }
`

export const ImgWrap = styled.div`
  transition: 0.5s;
`
export const Title = styled.div`
  color: var(--light);
  ${mediaMax('mobile')} {
    &.h2 {
      font-size: ${calculateMobileResponsiveSize(30)};
      font-weight: 250;
      line-height: ${calculateMobileResponsiveSize(36)};
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
  }
`

export const Item = styled((props) => <Link {...props} />)`
  display: flex;
  position: relative;
  overflow: hidden;
  width: 25%;
  background: var(--black);

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.1;
    transition: 0.5s;
    mix-blend-mode: multiply;
  }

  &:hover {
    &:after {
      opacity: 0;
    }
    ${ImgWrap} {
      transform: scale(1.13);
    }

    ${Content} {
      a {
        transform: translateY(${calculateResponsiveSize(0)});
      }
    }
  }
  ${mediaMax('mobile')} {
    width: 50%;
  }
`
